// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
export const firebaseConfig = {
	apiKey: "AIzaSyCLthThNp9skC-8jmEWJww1zYN5M5kkAoE",
	authDomain: "sudo-quiz.firebaseapp.com",
	projectId: "sudo-quiz",
	storageBucket: "sudo-quiz.appspot.com",
	messagingSenderId: "887584376136",
	appId: "1:887584376136:web:1c270d81c744a1544c1f7d",
};
